import script from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureMappingsStep.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureMappingsStep.vue?vue&type=style&index=0&id=85af361a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85af361a"]])

export default __exports__